import React from "react";
import { useSelector } from "react-redux";
import NonTypical from "../../service-steps/signs-and-symptoms/non-typical";
import Typical from "../../service-steps/signs-and-symptoms/typical";
import Infective from "../../service-steps/signs-and-symptoms/infective";

const SignsAndSymptoms = () => {
  const { clinicalServiceObj } = useSelector((state) => state.clinicalService);
  const { currentSubStep } =
    clinicalServiceObj.initialAssessment.initialAssessmentForm;

  const renderStep = () => {
    const subStep = currentSubStep;
    switch (subStep) {
      case 1:
        return <NonTypical />;
      case 2:
        return <Typical />;
      case 3:
        return <Infective />;
    }
  };
  return renderStep();
};

export default SignsAndSymptoms;
